import React, { useState } from "react";
import styles from "./ThemeCustomizer.module.css";

const ThemeCustomizer = ({ chatSettings, setChatSettings }) => {
  console.log("chatSettings in ThemeCustomizer:", chatSettings);
  console.log("Current theme_mode:", chatSettings?.theme?.theme_mode);

  // Preset themes
  const themePresets = {
    light: {
      header_theme: { backgroundColor: "#ffffff", textColor: "#000000" },
      chat_opener_theme: { backgroundColor: "#f0f0f0", textColor: "#000000" },
      chat_box_theme: { backgroundColor: "#ffffff", textColor: "#000000" },
    },
    Dark: {
      header_theme: { backgroundColor: "#000000", textColor: "#ffffff" },
      chat_opener_theme: { backgroundColor: "#333333", textColor: "#ffffff" },
      chat_box_theme: { backgroundColor: "#000000", textColor: "#ffffff" },
    },
  };

  // Update theme colors for individual fields
  const handleThemeChange = (section, field, value) => {
    const updatedSettings = {
      ...chatSettings,
      theme: {
        ...chatSettings.theme,
        [section]: {
          ...(chatSettings.theme?.[section] || {}),
          [field]: value,
        },
      },
    };
    console.log("Updating theme:", section, field, value, updatedSettings);
    setChatSettings(updatedSettings);
  };

  // Handle mode change for Light/Dark/None
  const handleModeChange = (value) => {
    console.log("Mode changed to:", value);

    let updatedSettings;

    if (value === "None") {
      // Reset to default theme colors
      updatedSettings = {
        ...chatSettings,
        theme: {
          ...chatSettings.theme,
          theme_mode: value,
          header_theme: {
            textColor: "#ffffff",
            backgroundColor: "#d00135",
          },
          chat_opener_theme: {
            textColor: "#ffffff",
            backgroundColor: "#a370ce",
          },
          chat_box_theme: {
            textColor: "#ffffff",
            backgroundColor: "#008000",
          },
        },
      };
    } else {
      // For Light/Dark themes, apply the preset
      updatedSettings = {
        ...chatSettings,
        theme: {
          ...chatSettings.theme,
          theme_mode: value,
          ...themePresets[value],
        },
      };
    }

    console.log("Updated theme settings:", updatedSettings);
    setChatSettings(updatedSettings);
  };

  const renderSection = (label, key) => {
    const section = chatSettings?.theme?.[key];
    if (!section) return null;

    return (
      <div className={styles.themeGroup}>
        <h4>{label}</h4>
        <div className={styles.themeRow}>
          <label>Background Color:</label>
          <input
            type="color"
            value={section.backgroundColor || "#ffffff"}
            onChange={(e) =>
              handleThemeChange(key, "backgroundColor", e.target.value)
            }
          />
        </div>
        <div className={styles.themeRow}>
          <label>Text Color:</label>
          <input
            type="color"
            value={section.textColor || "#000000"}
            onChange={(e) =>
              handleThemeChange(key, "textColor", e.target.value)
            }
          />
        </div>
      </div>
    );
  };

  // Add a safety check and default values
  if (!chatSettings || !chatSettings.theme) {
    console.log("No chatSettings or theme found, rendering null");
    return null;
  }

  return (
    <div className={styles.themeCustomizer}>
      <h3>Customize Chat Settings</h3>

      {/* Theme Mode Dropdown */}
      <div className={styles.themeGroup}>
        <h4>Theme Mode</h4>
        <select
          value={chatSettings.theme.theme_mode || "light"}
          onChange={(e) => handleModeChange(e.target.value)}
          className={styles.selectInput}
        >
          <option value="light">Light</option>
          <option value="Dark">Dark</option>
          <option value="None">None</option>
        </select>
        <div
          style={{
            fontSize: "12px",
            color: "#666",
            marginTop: "12px",
            fontStyle: "italic",
          }}
        >
          Current mode: {chatSettings.theme.theme_mode || "light"}
        </div>
      </div>

      <div className={styles.themeOuterWrapper}>
        <div className={styles.themeinnerWrapper}>
          {renderSection("Header Theme", "header_theme")}
          {renderSection("Chat Opener Theme", "chat_opener_theme")}
          {renderSection("Chat Box Theme", "chat_box_theme")}
        </div>
      </div>
    </div>
  );
};

export default ThemeCustomizer;
